import { toastDriverFactory } from '../Toast/Toast.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const statusToastDriverFactory = (base: UniDriver) => {
  const getContentRoot = () => base.get('[data-hook="status-toast-root"]');

  return {
    ...toastDriverFactory(base),
    getStatus: async () => (await getContentRoot()).attr('data-status'),
    getContent: async () => (await getContentRoot()).text(),
  };
};

export type StatusToastUniDriver = ReturnType<typeof statusToastDriverFactory>;
